import React from 'react';
import { useLoadScript } from '@react-google-maps/api';
import CategoryTree from '../components/CategoryTree';
import TopHeader from '../components/TopHeader';
import Footer from '../components/Footer';
import SearchFull from '../components/SearchFull';
import {  useDispatch } from "react-redux";
import { fetchSearchResults, setSearchParams } from '../store/slices/searchSlice';
import TopHeaderFull from '../components/TopHeaderFull';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const libraries = ['places'];

const CategoryPage = () => {
  const dispatch = useDispatch();
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const handleSearch = (searchData) => {
    dispatch(setSearchParams(searchData));
    dispatch(fetchSearchResults(searchData));
  };

  if (!isLoaded) {
    return null;
  }

  return (
    <div className="bg-white">
           <HelmetProvider>
                                  <Helmet>
                                    <title>Page liste catégories </title>
                                    <meta
                                      name="description"
                                      content="liste des catégories et sous catégories "
                                    />
                                  </Helmet>
                                </HelmetProvider>
      {/* <TopHeader />
      <SearchFull onSearch={handleSearch} isGoogleLoaded={isLoaded} category={true} /> */}
      <div className="sticky">
        <TopHeaderFull compact={true} /> 
      </div>
 
      <main className="container mt-40" >
        <h2 className='grey500 mb-0'>Découvrez nos services par catégories</h2>
        <CategoryTree onCategoryClick={handleSearch} />
      </main>
      <Footer />
    </div>
  );
};

export default CategoryPage;